import React, { useMemo } from 'react';

import { Chip, Stack, Typography } from '@mui/material';

import { buildRoomRateGroups } from './egsRoomMatcher';

interface Props {
  emptyMessage: string;
  roomRateIds: Array<string>;
  roomTypes: Array<App.RoomType>;
}

export default function EgsRoomRateList({ emptyMessage, roomRateIds, roomTypes }: Props) {
  const groups = useMemo(() => buildRoomRateGroups(roomRateIds, roomTypes), [roomRateIds, roomTypes]);

  if (groups.length === 0) {
    return (
      <Typography color="text.secondary" variant="body2">
        {emptyMessage}
      </Typography>
    );
  }

  return (
    <Stack spacing={1}>
      {groups.map((group) => (
        <Stack key={group.roomTypeId} alignItems="baseline" direction="row" flexWrap="wrap" gap={0.5}>
          <Typography fontWeight={600} sx={{ mr: 0.5 }} variant="body2">
            {group.roomTypeName}
          </Typography>
          {group.roomRates.map((roomRate) => (
            <Chip key={roomRate.roomRateId} label={roomRate.ratePlanName} size="small" variant="outlined" />
          ))}
        </Stack>
      ))}
    </Stack>
  );
}
